import { ElementRef, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { MandoobService } from 'src/app/options/mandoobs/mandoob.service';
import { Globle } from 'src/assets/globle';
import { MandoobStatment } from '../mandoobstatment.model';
import { ReportsService } from '../reports.service';
//import * as jsPDF from 'jspdf';
import { jsPDF } from 'jspdf';

//import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';
import { Customer } from 'src/app/options/customer.model';
import { CategoryService } from 'src/app/cards/category/category.service';
import { Category } from 'src/app/cards/category/category.model';


//declare let jsPDF;

@Component({
  selector: 'app-mandoobsstatment',
  templateUrl: './mandoobsstatment.component.html',
  styleUrls: ['./mandoobsstatment.component.css']
})
export class MandoobsstatmentComponent implements OnInit {

  reports: MandoobStatment[] = [];
  displayedColumns: string[] = ['date', 'userName', 'productName', 'userCatg', 'costPrice', 'quantity', "total", "phoneInfo"];
  dataSource!: MatTableDataSource<MandoobStatment>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;
  mandoobs: Customer[] = [];
  spinnerOverlay = false;
  selectedMandoob!: string;
  lang = 'en';
  reportObj: MandoobStatment = {} as MandoobStatment;
  pageSize = 100;
  categories: Category[] = [];
  selectedCategory: number = 0;
  constructor(private service: ReportsService,
    private mandoobService: MandoobService,
    private categoryService: CategoryService,
    private globle: Globle) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.getManddobs();
    this.getCategory();
  }

  getCategory() {
    this.categoryService.getAll(1).subscribe(data => {
      this.categories = data
    }, error => {
      console.log(error)
    })
  }

  getManddobs() {
    this.mandoobService.getAll().subscribe(data => {
      this.mandoobs = data
    }, error => {
      console.log(error)
    })
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getMandoobStatment(this.selectedMandoob, this.fromDate.nativeElement.value,
      this.toDate.nativeElement.value, this.selectedCategory).subscribe(data => {
        let obj = data

        this.reports = data;
        this.reports.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());


        this.dataSource = new MatTableDataSource(this.reports);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinnerOverlay = false;
      },
        error => {
          this.spinnerOverlay = false;
          console.log(error);
          this.reports = [];
          this.dataSource = new MatTableDataSource(this.reports);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
  }

  onApply() {
    this.get();
  }

  getTotalCostPrice() {
    var totalCost = 0;
    for (var i = 0; i < this.reports.length; i++) {
      if (this.reports[i].status != 2) {
        totalCost += this.reports[i].productCostPrice * this.reports[i].quantity
      }
    }
    return totalCost.toFixed(3);
  }

  getTotal() {
    var total = 0;
    for (var i = 0; i < this.reports.length; i++) {
      if (this.reports[i].status != 2) {
        total += this.reports[i].total
      }
    }
    return total.toFixed(3);
  }

  getProfits() {
    var total = this.getTotal();
    var totalCost = this.getTotalCostPrice()
    var profits = +total - +totalCost
    return profits.toFixed(3)
    // var costPric = 0;
    // var total = 0;
    // for (var i = 0; i < this.reports.length; i++) {
    //   costPric += this.reports[i].productCostPrice * this.reports[i].quantity;
    //   total += this.reports[i].total;
    // }
    // var profit = total - costPric;
    // return profit.toFixed(3);

    // return this.reports.map(t => t.total - t.productCostPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  Print() {

    const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

    doc.addFileToVFS("../../assets/Amiri/Amiri-Regular.ttf", this.globle.AmiriRegular);
    doc.addFont("../../assets/Amiri/Amiri-Regular.ttf", "Amiri", "normal");

    doc.setFont("Amiri");

    doc.setFontSize(18);
    doc.setTextColor(40);
    //doc.setFont("",'normal');

    doc.text("كشف مندوب ", 90, 10);
    doc.text("_________________________________", 50, 12);

    // set font
    doc.setFontSize(10);
    doc.viewerPreferences({ "Direction": "L2R" }, true);
    doc.text(" المندوب : " + this.mandoobs.find(x => x.id == this.selectedMandoob)?.fullName, 150, 20, {
      isOutputRtl: true,

    });

    if (this.fromDate.nativeElement.value != null && this.fromDate.nativeElement.value != ""
      && this.toDate.nativeElement.value != null && this.toDate.nativeElement.value != "") {
      doc.text(" من تاريخ : " + this.fromDate.nativeElement.value, 100, 20, {
        isOutputRtl: true
      });
      doc.text(" الى تاريخ : " + this.toDate.nativeElement.value, 50, 20, {
        isOutputRtl: true
      });
    }



    //autoTable({ html: '#orderProductTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    autoTable(doc, { html: '#mandoobTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    //doc.save("test.pdf");
    doc.output('dataurlnewwindow');
  }


}
